import script from "./WallOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./WallOverview.vue?vue&type=script&setup=true&lang=js"

import "./WallOverview.vue?vue&type=style&index=0&id=49f445d4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f445d4"]])

export default __exports__